export const FIRST_ACCESS_PAGE_KEY = 'BZNAV_SENA_FIRST_ACCESS_PAGE';
export const CURRENT_CHAT_ID_KEY = 'BZNAV_SENA_CURRENT_CHAT_ID';

export const LOADED_CONTENT_OBJECT_STORE = 'PRELOADED_CHAT_CONTENT_STORE';
